import { DateTime } from 'luxon'

import { BoxAllocationResponseDTO } from '@core/api/dtos/response/boxAllocation/boxAllocation'
import {
	BoxAllocation,
	BoxAllocationMetadata,
} from '@core/api/entities/boxAllocation'

export class BoxAllocationMapper {
	static toEntity = (dto: BoxAllocationResponseDTO): BoxAllocation => {
		return BoxAllocation.create({
			id: dto.id,
			playerId: dto.player_id,
			salesforceId: dto.salesforce_id,
			boxNumber: dto.box_number,
			operatingSystem: dto.operating_system,
			startDate: DateTime.fromISO(dto.start_date),
			endDate: DateTime.fromISO(dto.end_date),
			active: dto.active,
			model: dto.model,
			mdmDeviceId: dto.mdm_device_id,
			metadata: BoxAllocationMetadata.create({
				isGeneric: dto.metadata.is_generic,
				brand: dto.metadata.brand,
				osVersion: dto.metadata.os_version,
				ethernetMacAddress: dto.metadata.ethernet_mac_address,
				wifiMacAddress: dto.metadata.wifi_mac_address,
			}),
		})
	}

	static toEntities = (dtos: BoxAllocationResponseDTO[]): BoxAllocation[] => {
		return dtos.map(this.toEntity)
	}
}
